export class ContentInterstitialBanner {
  id: any;
  acSwitchText: any;
  acSwitchGenericText: any;
  businessLogo: any;
  imageList: any;
  progressImageUrl: any;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['id']) {
        this.id = contentjson['id'];
      }
      if (contentjson['acSwitchText']) {
        this.acSwitchText = contentjson['acSwitchText'];
      }
      if (contentjson['acSwitchGenericText']) {
        this.acSwitchGenericText = contentjson['acSwitchGenericText'];
      }
      if (contentjson['businessLogo']) {
        this.businessLogo = contentjson['businessLogo'];
      }
      if (contentjson['imageList']) {
        this.imageList = contentjson['imageList'];
      }
      if (contentjson['progressImageUrl']) {
        this.progressImageUrl = contentjson['progressImageUrl'];
      }
    }
  }
}
